import { Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
//import Context from "@ckeditor/ckeditor5-core/src/context";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
//import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
//-----------------------------------------------------------------------------------------
import FileSystem from "src/components/common/fileSystem";
import UserInfo from "src/components/common/userInfo";
import { useMyStore } from "src/components/main/mainStore";
import {
    defaultEmptyDateTime
} from "src/components/common/functions";
import WorkLogs from "./worLogs/workLogs";
//-----------------------------------------------------------------------------------------
export default function WorkInstructionDetail({
    title, 
    totalHours, 
    siteContacts, 
    projectId, 
    setCurrentWorkInstruction, 
    setWorkInstructions, 
    workInstructions, 
    workInstruction, 
    workInstructionId, 
    currentWorkLogs, 
    setCurrentWorkLogs,

    loadingWorkLogs
}){
    const user = useMyStore(state => state.user);
    return(
    <div className = "border rounded px-3">
        <div className = "cssSeperateWhenWide pl-3 pt-3">
            <div className = "flex-grow-1 maxWidth-50 mr-3">
                <div className = "mb-3">
                    <label className = "h5">Creator:</label>
                    <UserInfo email = {workInstruction.workInstructionCreatorEmail} name = {workInstruction.creator}/>
                    <span className = "ml-3">{workInstruction.workInstructionCreationDate}</span>
                </div>
                {workInstruction.workInstructionUpdaterEmail?
                <div className = "mb-3">
                    <label className = "h5">Updater:</label>
                    <UserInfo email = {workInstruction.workInstructionUpdaterEmail} name = {workInstruction.updater}/>
                    <span className = "ml-3">{workInstruction.workInstructionDateUpdated}</span>
                </div>
                :null}
                <div className = "mb-3">
                    <label className = "h5">Description:</label>
                    <CKEditor
                        editor = {ClassicEditor}
                        onReady = {e => {
                            if(e && e.sourceElement.nextElementSibling){
                                e.sourceElement.nextElementSibling.children[1].style.display = "none";
                                e.sourceElement.nextElementSibling.children[2].children[0].style.border = "none";
                            }
                        }}
                        config = {{
                            toolbar: []
                        }}
                        disabled = {true} 
                        data = {workInstruction.workInstructionDescription}
                    />
                </div>
                <div className = "mb-3">
                    <label className = "h5">Location:</label>
                    <Link to = {`/Map/${workInstruction.workInstructionHashKey}`}>
                        {workInstruction.location}
                    </Link>
                </div>
                {workInstruction.category !== "GPR Concrete Scanning and Coring Project"?
                <div className = "mb-3">
                    <label className = "h5">Supervisor:</label>
                    <UserInfo email = {workInstruction.supervisorEmail} name = {workInstruction.supervisor}/>
                </div>
                :
                <div className = "mb-3 user-select-text">
                    <label className = "h5">Client Supervisor:</label>
                    <label>{workInstruction.fieldSupervisorName} &mdash; {workInstruction.fieldSupervisorEmail}</label>
                </div>
                }
                <div className = "mb-3">
                    <label className = "h5">Site Contact:</label>
                    {workInstruction.siteContactHashKey?
                    <Link to = {`/Contacts/${workInstruction.siteContactHashKey}`}>
                        {
                            siteContacts.filter(siteContact => siteContact.contactHashKey === workInstruction.siteContactHashKey)[0]?.contactName
                        } &mdash; {
                            siteContacts.filter(siteContact => siteContact.contactHashKey === workInstruction.siteContactHashKey)[0]?.mobile
                        }
                    </Link>
                    :null}
                </div>
                <div className = "mb-3">
                    <label className = "h5">CAD Required:</label>
                    {workInstruction.cadRequired === null?"":(workInstruction.cadRequired === "1"?"Yes":"No")}
                </div>
                <div className = "mb-3">
                    <label className = "h5">Report Required:</label>
                    {workInstruction.reportRequired === null?"":(workInstruction.reportRequired === "1"?"Yes":"No")}
                </div>
            </div>
            <div className = "flex-grow-1 maxWidth-50 mr-3">
                <div className = "mb-3">
                    <FileSystem
                        fileSystem = {[{title: "Work Instruction Attachments"}]}
                        item = {workInstruction}
                        setItems = {setWorkInstructions} 
                        items = {workInstructions}
                        sqlTable = "workInstructions"
                        itemLabel = "work instruction"
                        hashKeyLabel = "workInstructionHashKey"
                        filesKey = "workInstructionFiles"
                        singleFolderId = "attachmentFolderId"
                        calendarId = {workInstruction.calendarId}
                        eventId = {workInstruction.eventId}
                        readOnly = {user.projects === "readOnly"}
                    />
                </div>
                {totalHours !== null && totalHours.length && totalHours.filter(t => t.workInstructionHashKey === workInstruction.workInstructionHashKey && t.jobTagSubmitTime !== defaultEmptyDateTime).length?
                <div>
                    <table>
                        <thead>
                            <tr>
                                <th>Department</th>
                                <th>Work Hours</th>
                                <th>Travel Hours</th>
                                <th>Total Hours</th>
                            </tr>
                        </thead>
                        <tbody>
                            {workInstruction.laborHoursDetail?workInstruction.laborHoursDetail.map((d, key) => 
                            <tr key = {key}>
                                <td>{d[0]}</td>
                                    <td>
                                        {d[1]}
                                    </td>
                                    <td>
                                        {d[2]}
                                    </td>
                                    <td>
                                        {d[3]}
                                    </td>
                            </tr>
                            ):null}
                        </tbody>
                    </table>
                </div>
                :null}
            </div>
        </div>
        <WorkLogs
                title = {title}
                totalHours = {totalHours}

                projectId = {projectId} 

                workInstruction = {workInstruction}
                setCurrentWorkInstruction = {setCurrentWorkInstruction}
                workInstructionId = {workInstructionId}

                currentWorkLogs = {currentWorkLogs}
                setCurrentWorkLogs = {setCurrentWorkLogs}

                setWorkInstructions = {setWorkInstructions}

                loadingWorkLogs = {loadingWorkLogs}
            />
    </div>)
}
